import { atom, useAtom } from "jotai";

export const chatEnvironmentAtom = atom(undefined);

export function useChatEnvironmentAtom() {
    return useAtom(chatEnvironmentAtom);
}
